import Noitem from './Noitem.vue';
export default Noitem;



// WEBPACK FOOTER //
// ./src/components/parts/noitem/index.ts